import { Form, Input, Space } from 'antd';
// import styles from '../index.module.less';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
// import { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import CustomModal from '@/common/CustomModal';
import { CheckOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { completeFollowUp, selectFollowUpSlice } from '../redux/slice';

export default function MarkAsCompleteModal({
  isOpen,
  setIsOpen,
  onAssign,
  data
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { completeFollowUpLoading } = useSelector(selectFollowUpSlice);

  const handleClose = () => {
    setIsOpen(null);
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({
      followup_outcome: ''
    });
  }, [isOpen]);

  const onFinish = (values) => {
    const payload = {
      ...values,
      id: isOpen
    };
    dispatch(completeFollowUp(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[50%] md:!w-[40%] lg:!w-[35%] xl:!w-[30%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          Complete follow-up
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="What was the outcome?"
            name="followup_outcome"
            rules={[{ required: true, message: 'Outcome is required' }]}
            className={styles.customLable}
          >
            <Input.TextArea
              rows={3}
              placeholder="Describe the outcome of this follow-up"
            />
          </FormItem>

          {/* <FormItem
            label="Did this follow-up lead to any action items?"
            name="action_items"
            rules={[{ required: true }]}
            className={styles.customLable}
          >
            <Radio.Group
              buttonStyle="solid"
              size="small"
              onChange={(e) => console.log(e.target.value)}
            >
              <Radio value="yes" className={styles.projectText}>
                Yes
              </Radio>
              <Radio value="no" className={styles.projectText}>
                No
              </Radio>
            </Radio.Group>
          </FormItem> */}
        </div>
        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              icon={<CheckOutlined />}
              loading={completeFollowUpLoading}
            >
              Mark As Done
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
